import axios from "axios";
import { retrieveData } from "../LocalConnection/LocalConnection.js";
let APL_LINK = "http://192.168.1.5:8000/";
APL_LINK = "https://backendpython.uprestro.com/";
let Website_URL = "https://www.uprestro.com";
let version_vi_api_admin = APL_LINK + "api/v1/admin/";
const SECRET_KEY = "UPRESTRO_POS_202";
//new Vi api admin
const login_to_admin = version_vi_api_admin + "login_to_admin";
const get_last_resturant = version_vi_api_admin + "get_last_resturant";
const get_new_resturant = version_vi_api_admin + "get_new_resturant";
const save_onboarding = version_vi_api_admin + "save_onboarding";
const contact_save = version_vi_api_admin + "contact_save";
const update_lead = version_vi_api_admin + "update_lead";
const toggle_restaurant_access_control =
  version_vi_api_admin + "toggle_restaurant_access_control";
const get_restaurant_security_logs =
  version_vi_api_admin + "get_restaurant_security_logs";
const get_restaurant_access_control_list =
  version_vi_api_admin + "get_restaurant_access_control_list";
const save_update_testimonial_api =
  version_vi_api_admin + "save_update_testimonial_api";
const get_all_restaurantowner =
  version_vi_api_admin + "get_all_restaurantowner";
const get_testimonial = version_vi_api_admin + "get_testimonial";
const save_update_adminstaff = version_vi_api_admin + "save_update_admin_staff";
const get_all_adminstaff = version_vi_api_admin + "get_all_adminstaff";
const action_adminstaff = version_vi_api_admin + "action_adminstaff";
const save_update_admindesigntion =
  version_vi_api_admin + "save_update_admindesigntion";
const get_faq = version_vi_api_admin + "get_faq";
const get_all_resturant_onboarding =
  version_vi_api_admin + "get_all_resturant_onboarding";
const update_profile_adminstaff =
  version_vi_api_admin + "update_profile_adminstaff";
const save_update_knowledge_base =
  version_vi_api_admin + "save_update_knowledge_base";
const get_all_knowledge_base = version_vi_api_admin + "get_all_knowledge_base";
const gst_verification = version_vi_api_admin + "gst_verification";
const get_lead = version_vi_api_admin + "get_lead";
const send_otp_for_pos_onboarding =
  version_vi_api_admin + "send_otp_for_pos_onboarding";
const save_subscription = version_vi_api_admin + "save_subscription";
const new_restaurant_install = version_vi_api_admin + "new_restaurant_install";
const get_reservation_reports =
  version_vi_api_admin + "get_reservation_reports";
const get_guest_reports = version_vi_api_admin + "get_guest_reports";
const get_sales_reports_admin =
  version_vi_api_admin + "get_sales_reports_admin";
const save_update_search_master =
  version_vi_api_admin + "save_update_search_master";
const get_searchmaster = version_vi_api_admin + "get_searchmaster";
const save_update_del_faq = version_vi_api_admin + "save_update_del_faq";
const restaurant_subscriptions =
  version_vi_api_admin + "restaurant_subscriptions";
const fssai_verification = version_vi_api_admin + "fssai_verification";
const get_subscription_data = version_vi_api_admin + "get_subscription_data";
const get_admin_faq = version_vi_api_admin + "get_admin_faq";
const save_update_del_admin_faq =
  version_vi_api_admin + "save_update_del_admin_faq";
const save_restaurant_subs = version_vi_api_admin + "save_restaurant_subs";
const get_admin_dashboard_data =
  version_vi_api_admin + "get_admin_dashboard_data";
const get_restaurant_list = version_vi_api_admin + "get_restaurant_list";
const get_all_ticket_details = version_vi_api_admin + "get_all_ticket_details";
const get_save_update_support_tickets =
  version_vi_api_admin + "get_save_update_support_tickets";
const resolve_tickets = version_vi_api_admin + "resolve_tickets";
const get_tickets = version_vi_api_admin + "get_tickets";
const del_super_master_data = version_vi_api_admin + "del_super_master_data";
const save_update_website_management =
  version_vi_api_admin + "save_update_website_management";
const get_website_management_details =
  version_vi_api_admin + "get_website_management_details";
const update_career_data = version_vi_api_admin + "update_career_data";
const create_update_vacancy = version_vi_api_admin + "create_update_vacancy";
const get_vacancy = version_vi_api_admin + "get_vacancy";
const del_website_master_data =
  version_vi_api_admin + "del_website_master_data";
const get_update_terms_privacy_policy =
  version_vi_api_admin + "get_update_terms_privacy_policy";
const get_imagelink = version_vi_api_admin + "get_imagelink";
const save_update_image_link = version_vi_api_admin + "save_update_image_link";
const get_seo_data = version_vi_api_admin + "get_seo_data";
const save_update_seo_api = version_vi_api_admin + "save_update_seo_api";
const get_blogs = version_vi_api_admin + "get_blogs";
const save_update_blog_api = version_vi_api_admin + "save_update_blog_api";
const get_subscribe_list = version_vi_api_admin + "get_subscribe_list";
const get_restro_analytics = version_vi_api_admin + "get_restro_analytics";
const get_restaurants_owner_report =
  version_vi_api_admin + "get_restaurants_owner_report";
const get_restaurants_report = version_vi_api_admin + "get_restaurants_report";
const update_notification_read_status =
  version_vi_api_admin + "update_notification_read_status";
const get_all_unread_notification =
  version_vi_api_admin + "get_all_unread_notification";
const get_admin_designation = version_vi_api_admin + "get_admin_designation";
const action_update_admin_staffrights =
  version_vi_api_admin + "action_update_admin_staffrights";
const save_update_admin_staff_rights =
  version_vi_api_admin + "save_update_admin_staff_rights";
const get_admin_staffrights = version_vi_api_admin + "get_admin_staffrights";
const get_all_resturant = version_vi_api_admin + "get_all_resturant";
const action_resturant = version_vi_api_admin + "action_resturant";

const get_all_plans = version_vi_api_admin + "get_all_plans";
const save_update_custom_plan =
  version_vi_api_admin + "save_update_custom_plan";
const update_plan_features = version_vi_api_admin + "update_plan_features";
const assign_standard_plan = version_vi_api_admin + "assign_standard_plan";
const delete_custom_plan = version_vi_api_admin + "delete_custom_plan";
const extend_plan_duration = version_vi_api_admin + "extend_plan_duration";
const get_restaurant_plan_features =
  version_vi_api_admin + "get_restaurant_plan_features";
const get_plan_detail = version_vi_api_admin + "get_plan_detail";
const get_restaurant_plan_history =
  version_vi_api_admin + "get_restaurant_plan_history";
const seed_standard_plans = version_vi_api_admin + "seed_standard_plans";
const logoutAndClearData = () => {
  // Clear all stored data
  localStorage.clear();
  sessionStorage.clear();

  // Optional: redirect to login page
  window.location.href = "/"; // apna login route yahan daalein
};

const server_post_data = async (
  url_for,
  form_data,
  packageName = "Default",
) => {
  try {
    const access_token = retrieveData("access_token");
    const retrievedAdminId = retrieveData("admin_id");
    if (form_data === null) {
      form_data = new FormData();
    }
    form_data.append("admin_id", "0");
    form_data.append("super_admin_id", retrievedAdminId);
    form_data.append("platform_type", "panel");
    form_data.append("app_name", "AdminWeb");
    if (form_data.get("data_call") !== null) {
      form_data.append("call_id", retrievedAdminId);
    }

    const response = await axios.post(url_for, form_data, {
      headers: {
        "X-Package-Name": packageName,
        ...(access_token &&
          access_token !== "1" &&
          url_for !== login_to_admin && {
            Authorization: `Bearer ${access_token}`,
          }),
      },
    });
    return response;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      console.log("Session expired. Logging out...");
      logoutAndClearData();
    }

    throw error;
  }
};

export {
  APL_LINK,
  Website_URL,
  SECRET_KEY,
  server_post_data,
  toggle_restaurant_access_control,
  get_restaurant_security_logs,
  get_restaurant_access_control_list,
  get_new_resturant,
  get_website_management_details,
  save_update_website_management,
  save_update_testimonial_api,
  del_website_master_data,
  get_testimonial,
  action_update_admin_staffrights,
  action_adminstaff,
  get_all_adminstaff,
  get_searchmaster,
  save_update_knowledge_base,
  get_all_knowledge_base,
  get_faq,
  get_admin_designation,
  update_career_data,
  get_vacancy,
  get_update_terms_privacy_policy,
  save_restaurant_subs,
  restaurant_subscriptions,
  save_update_seo_api,
  get_seo_data,
  get_restaurant_list,
  get_reservation_reports,
  get_restaurants_report,
  new_restaurant_install,
  action_resturant,
  get_all_resturant,
  get_all_restaurantowner,
  get_sales_reports_admin,
  get_restaurants_owner_report,
  get_all_ticket_details,
  get_tickets,
  update_profile_adminstaff,
  get_last_resturant,
  save_onboarding,
  gst_verification,
  fssai_verification,
  send_otp_for_pos_onboarding,
  save_subscription,
  get_subscription_data,
  get_all_resturant_onboarding,
  del_super_master_data,
  login_to_admin,
  update_lead,
  get_lead,
  contact_save,
  get_admin_staffrights,
  resolve_tickets,
  get_guest_reports,
  get_admin_faq,
  save_update_del_admin_faq,
  get_subscribe_list,
  get_admin_dashboard_data,
  get_save_update_support_tickets,
  save_update_admin_staff_rights,
  save_update_blog_api,
  get_restro_analytics,
  get_blogs,
  create_update_vacancy,
  save_update_adminstaff,
  save_update_image_link,
  get_imagelink,
  save_update_admindesigntion,
  save_update_search_master,
  save_update_del_faq,
  update_notification_read_status,
  get_all_unread_notification,
  get_all_plans,
  save_update_custom_plan,
  update_plan_features,
  assign_standard_plan,
  delete_custom_plan,
  extend_plan_duration,
  get_restaurant_plan_history,
  get_restaurant_plan_features,
  get_plan_detail,
  seed_standard_plans,
};
